import React, { useEffect, createElement } from 'react';
import { SalesPage } from './components/SalesPage';
import { CountdownTimer } from './components/CountdownTimer';
import { SocialProofPopup } from './components/SocialProofPopup';
function App() {
  useEffect(() => {
    // Meta Pixel Code
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '836421405954360');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `
      <img height="1" width="1" style="display:none"
      src="https://www.facebook.com/tr?id=836421405954360&ev=PageView&noscript=1"
      />
    `;
    document.body.appendChild(noscript);
    return () => {
      // Cleanup if needed, though usually pixel persists
    };
  }, []);
  return <div className="min-h-screen bg-white" data-id="element-0">
      <CountdownTimer data-id="element-1" />
      <SalesPage data-id="element-2" />
      <SocialProofPopup data-id="element-3" />
    </div>;
}
export { App };